// initial state
const state = {
  loading: false,
  error: false,
  online: false
};

const getters = {
  loading(state) {
    return state.loading;
  },
  error(state) {
    return state.error;
  },
  online(state) {
    return state.online;
  }
};

// actions
const actions = {};

// mutations
const mutations = {
  setLoading(state, payload) {
    state.loading = payload;
  },
  clearLoading(state) {
    state.loading = false;
  },
  setError(state, payload) {
    state.error = payload;
  },
  clearError(state) {
    state.error = false;
  },
  setOnline(state) {
    state.online = true;
  },
  setOffline(state) {
    state.online = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
